import * as React from "react";
const SvgFiRrCoffeeBeans = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-coffee-beans_svg__a)">
      <path
        fill="#062147"
        d="M18 9.009c-3.309 0-6 3.365-6 7.5 0 4.137 2.691 7.5 6 7.5s6-3.363 6-7.5c0-4.135-2.691-7.5-6-7.5m-4 7.5c0-2.76 1.485-5.05 3.414-5.441.38.57 1.235 2.322-.277 4.942-1.302 2.258-1.289 4.11-.94 5.409-1.303-.908-2.198-2.768-2.198-4.91zm4.592 5.44c-.38-.571-1.232-2.32.278-4.94 1.301-2.254 1.289-4.104.941-5.403 1.298.91 2.189 2.767 2.189 4.904 0 2.756-1.482 5.045-3.408 5.44M12.507 1.494C11.317.303 9.609-.201 7.707.07c-1.799.257-3.58 1.188-5.014 2.623-3.036 3.036-3.575 7.439-1.2 9.814.979.979 2.307 1.495 3.809 1.495q.485 0 .991-.072c1.799-.257 3.58-1.188 5.014-2.623 3.036-3.036 3.575-7.44 1.2-9.814M4.108 4.107c1.13-1.13 2.509-1.86 3.882-2.057q.359-.051.698-.052c.727 0 1.379.175 1.911.512-.218.723-1.038 2.543-3.926 3.543-2.55.884-3.888 2.328-4.586 3.514-.375-1.65.354-3.794 2.021-5.46m5.785 5.785c-1.13 1.13-2.509 1.86-3.882 2.057-1.012.144-1.913-.02-2.609-.461.218-.724 1.038-2.542 3.926-3.543 2.55-.884 3.888-2.328 4.586-3.514.375 1.65-.354 3.795-2.021 5.46"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-coffee-beans_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCoffeeBeans;
